export default [
    {
        path: '/sales',
        name: 'Company / Sales Overview',
        component: () => import('@/views/pages/sales/overview'),
        meta:
        {
            name: 'Sales Overview',
        },
    },
    {
        path: '/sales/comparison',
        name: 'Company / Sales Comparison',
        component: () => import('@/views/pages/sales/comparison'),
        meta:
        {
            name: 'Sales Comparison',
        },
    },
];